import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BrandBook from "./pages/BrandBook";
import Website from "./pages/Website";
import { LangProvider } from "./lib/LangContext";
import { ModeProvider } from "./lib/ModeContext";

function App() {
    return (
        <LangProvider>
            <ModeProvider>
                <div className="App">
                    <BrowserRouter>
                        <Routes>
                            <Route path="/" element={<Website />} />
                            <Route path="/brand-book" element={<BrandBook />} />
                            <Route path="*" element={<Website />} />
                        </Routes>
                    </BrowserRouter>
                </div>
            </ModeProvider>
        </LangProvider>
    );
}

export default App;
